import api from './api';
import { endpoints } from './endpoints';

/** Hero / contact bir vaqtda chaqirganda takroriy so‘rovni oldini olish */
const CACHE_TTL_MS = 5 * 60 * 1000;
let cacheEntry = { list: null, at: 0 };
let inflightPromise = null;

function ensureList(res) {
  if (!res || typeof res !== 'object') return [];
  if (Array.isArray(res.data)) return res.data;
  if (Array.isArray(res.data?.data)) return res.data.data;
  if (Array.isArray(res.business_types)) return res.business_types;
  if (Array.isArray(res)) return res;
  return [];
}

function normalizeItem(raw) {
  if (!raw) return null;
  const name = raw.display_name ?? raw.name_uz ?? raw.name_ru ?? raw.name_oz ?? raw.name ?? raw.name_key ?? '';
  return {
    id: raw.id ?? raw,
    name,
    name_uz: raw.name_uz ?? null,
    name_ru: raw.name_ru ?? null,
    name_oz: raw.name_oz ?? null,
    nameKey: raw.name_key ?? raw.nameKey ?? null,
    slug: raw.slug ?? (raw.name_key || (typeof raw.name === 'string' ? raw.name.toLowerCase() : '')),
    iconUrl: raw.icon_url ?? raw.icon_svg ?? null,
    descriptionKey: raw.description_key ?? null,
  };
}

/** Sinxron: kesh bo‘lsa ro‘yxat, yo‘q bo‘lsa null (birinchi renderda kechikmaslik uchun). */
export function getBusinessTypesCachePeek() {
  const now = Date.now();
  if (cacheEntry.list != null && now - cacheEntry.at < CACHE_TTL_MS) {
    return cacheEntry.list;
  }
  return null;
}

export async function getBusinessTypes() {
  const now = Date.now();
  if (cacheEntry.list && now - cacheEntry.at < CACHE_TTL_MS) {
    return cacheEntry.list;
  }
  if (inflightPromise) {
    return inflightPromise;
  }
  inflightPromise = (async () => {
    try {
      const res = await api.get(endpoints.businessTypes);
      const list = ensureList(res)
        .map(normalizeItem)
        .filter((x) => x && x.name);
      cacheEntry = { list, at: Date.now() };
      return list;
    } finally {
      inflightPromise = null;
    }
  })();
  return inflightPromise;
}
